import { trace } from "@opentelemetry/api";
import { Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

const tracer = trace.getTracer("customer-portal-ui");

function reportWebVital(metric: Metric) {
  const span = tracer.startSpan(`web_vital.${metric.name.toLowerCase()}`, {
    attributes: {
      "metric.name": metric.name,
      "metric.value": metric.value,
      "metric.rating": metric.rating,
      "metric.delta": metric.delta,
      "metric.id": metric.id,
      "navigation.type": metric.navigationType,
    },
  });
  span.end();
}

export function initWebVitals() {
  onCLS(reportWebVital);
  onINP(reportWebVital);
  onLCP(reportWebVital);
  onFCP(reportWebVital);
  onTTFB(reportWebVital);
}
